module.exports = __webpack_public_path__ + "img/internal-case-notes_1.31886d3f.svg";